import { css, Global } from "@emotion/react";
import type { ReactElement } from "react";
import {
  APP_RECEDE_TRANSFORM,
  CARD_MODAL_BREAKPOINT,
  CARD_MODAL_RADIUS,
  RECEDE_TRANSITION
} from "./modalConstants";

/**
 * Global styles for the iOS card-modal recede effect. The host app marks its
 * main content with `data-modal-presenting`; this CSS scales/translates that
 * element whenever a center-variant modal is open on mobile, matching the
 * default IonModal presentation. No-op on tablet/desktop.
 *
 * `useModalStack` toggles `data-card-modal-open` on <body>.
 */
export const ModalGlobalStyles = (): ReactElement => (
  <Global
    styles={css`
      @media ${CARD_MODAL_BREAKPOINT} {
        [data-modal-presenting] {
          transition: ${RECEDE_TRANSITION};
          transform-origin: 50% 0;
          will-change: transform;
        }
        body[data-card-modal-open] [data-modal-presenting] {
          transform: ${APP_RECEDE_TRANSFORM};
          border-top-left-radius: ${CARD_MODAL_RADIUS};
          border-top-right-radius: ${CARD_MODAL_RADIUS};
          overflow: hidden;
        }
        @media (prefers-reduced-motion: reduce) {
          [data-modal-presenting] {
            transition-duration: 1ms;
          }
        }
      }
    `}
  />
);
